import React, { lazy, ReactNode, Suspense, useMemo } from "react";
import store from "@redux/store";
import { BRAND_LIST } from "@type/index";

import { ConfigProviderContext } from "fr-ito-web-react/react/esm";
import "fr-ito-web-react/css/main.css";
import "fr-ito-web-react/css/main.global.css";
import "fr-ito-web-react/css/variables.css";
// import "fr-ito-web-react/css/main.fonts.css";
// import "@uq-global-ec/ec-components/main.css";
import * as icons from "brand-fr-ito-icons";

interface DynamicComponentProps {
  children?: ReactNode;
}

const { brand_name, language, region } = store.getState().config;

const LazyLayout = lazy(() => {
  switch (brand_name) {
    case BRAND_LIST.UQ:
      return import("../UQLayout");
    case BRAND_LIST.GU:
      return import("../GULayout");
    case BRAND_LIST.PL:
      return import("../PLLayout");
    default:
      return import("../UQLayout");
  }
});

const DynamicComponent = ({ children }: DynamicComponentProps) => {
  const ITOConfigProviderValue = useMemo(
    () => ({
      theme: brand_name,
      lang: `${language}-${region.toUpperCase()}`,
      icons
    }),
    []
  );

  return (
    <ConfigProviderContext.Provider value={ITOConfigProviderValue}>
      <Suspense>
        <LazyLayout>{children}</LazyLayout>
      </Suspense>
    </ConfigProviderContext.Provider>
  );
};

export default DynamicComponent;
